import { PrintableTickets, PrintFormat } from './types';

export const ticketPdfEndpoints = (tickets: PrintableTickets, format: PrintFormat): string[] => {
	if (tickets.transactionId) {
		const thermal = format === 'thermal' ? '?boxOffice=true' : '';
		return [`/download/pdf_tickets/${tickets.transactionId}${thermal}`];
	}
	// No letter-size per-ticket template exists, so standard has no fallback.
	if (format !== 'thermal') return [];
	return (tickets.ticketIds ?? []).map((id) => `/download/pdf_ticket/${id}`);
};

export const canPrint = (tickets: PrintableTickets, format: PrintFormat): boolean =>
	ticketPdfEndpoints(tickets, format).length > 0;
